import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { companyParametersSelectors } from 'src/features/companyParameters/companyParameters.state';
import { CompanyParameters, CompanyParametersRecord } from 'src/features/companyParameters/companyParameters.types';

export const useCompanyParametersState = (): RootState['companyParameters'] => {
  const state = useSelector<RootState, RootState['companyParameters']>(state => state.companyParameters);

  useDebugValue(state);

  return state;
};

export const useCompanyParameters = (id: string): CompanyParameters | undefined => {
  const state = useSelector<RootState, RootState['companyParameters']>(state => state.companyParameters);

  const result = companyParametersSelectors.selectById(state, id);

  useDebugValue(result);

  return result;
};

export const useCompanyParametersCheckins = (id: string): CompanyParametersRecord[] => {
  const state = useSelector<RootState, RootState['companyParameters']>(state => state.companyParameters);

  const result = companyParametersSelectors.selectById(state, id);

  useDebugValue(result);

  return result?.checkins || [];
};

export const useCompanyParametersWorkingHeadsets = (id: string): CompanyParametersRecord[] => {
  const state = useSelector<RootState, RootState['companyParameters']>(state => state.companyParameters);

  const result = companyParametersSelectors.selectById(state, id);

  useDebugValue(result);

  return result?.devices || [];
};
